//Imports node_modules
import React, { useContext, useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group';
import Modal from 'react-modal';
import Cookies from 'universal-cookie';

//Imports Css
import './modalPickupFuncionario.css'

//Import Images 
import nodoc from './nodoc.svg'
import user from './user.svg'
import unchecked from './unchecked.svg'
import checkbox from './checkbox.svg'

//Imports Components

//Import Data
import { globalModals } from '../../../../data/GlobalModals'
import { axiosCalls } from '../../../../data/AxiosCalls';
import LoadingLayout from '../loadingLayout/LoadingLayout';
import { Link } from 'react-router-dom';


//Layout de navegação na parte inferior da aplicação
const ModalPickupFuncionario = (params) => {

    const {

    } = useContext(globalModals)

    const {
        AxiosPost
    } = useContext(axiosCalls)


    //---------------------------Operações para ler o resize da página----------------------------
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [divModalSizeHeight, setDivModalSizeHeight] = useState(0);
    const [dimensions, setDimensions] = React.useState({ width: window.innerWidth, height: window.innerHeight, });
    const handleResize = () => { setDimensions({ width: window.innerWidth, height: window.innerHeight, }); }
    React.useEffect(() => { window.addEventListener("resize", handleResize, false); }, []);
    React.useEffect(() => { if (dimensions.width < 992) { setIsSmallScreen(true); } else { setIsSmallScreen(false) } setDivModalSizeHeight(dimensions.height); }, [dimensions]);
    //---------------------------Fim Operações para ler o resize da página------------------------


    const cookies = new Cookies();
    const [employeeList, setEmployeeList] = useState([])
    const [isLoadingEmployee, setIsLoadingEmployee] = useState(false)

    const [selectedList, setSelectedList] = useState([])

    useEffect(() => {

        if (params.isOpen) {
            setIsLoadingEmployee(true)
            AxiosPost(('Production/showCurrentFuncInProduction?groupStamp=' + localStorage.getItem('grupostamp') + '&jorneystamp=' + localStorage.getItem('jorneystamp')),
                'function',
                function computeEmptyReponse() {
                    setIsLoadingEmployee(false)
                    setEmployeeList([])
                },
                function computeReponse(response) {
                    setIsLoadingEmployee(false)
                    setEmployeeList(response.data)
                });
        }
    }, [params.isOpen])

    function setClientList(employeeNPE){
        var arrayList = JSON.parse(JSON.stringify(selectedList))

        if(arrayList.includes(employeeNPE)){
            arrayList = arrayList.filter(item => item !== employeeNPE);
        }else{
            arrayList.push(employeeNPE)
        }

        setSelectedList(arrayList)
    }

    function nextClick(){
        //Junta as lista de funcionarios com a selecionadas para criar o objecto final
        const finalList = employeeList.filter(employee => selectedList.includes(employee.npe));
        params.nextFunction(finalList)
    }

    function renderContent() {
        return (
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className={'modal-header success'}>
                        <h4 className="modal-title" id="staticBackdropLabel">
                            <i className={'fa fa-list'} aria-hidden="true" style={{ marginRight: '10px', fontSize: '20px', padding: '0px' }}></i>Lista de funcionários em obras
                        </h4>
                    </div>
                    <div className="modal-body" style={{ whiteSpace: 'preWrap' }}>
                        {isLoadingEmployee ?
                            <LoadingLayout>
                            </LoadingLayout>
                            :
                            employeeList.length > 0 ?
                                <div className='flexLayoutScrollable' style={{ height: dimensions.height - 400 }}>
                                    <ul className="RDashList">
                                        {employeeList.map((employee, index) =>
                                            <li key={params.chave} className={'RdashListItem'} style={selectedList.includes(employee.npe) ? { backgroundColor: '#e4f5d5' }: { backgroundColor: '#E4EDF4' }} onClick={e => setClientList(employee.npe)}>
                                                <Link
                                                    to="#"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <div className='listItemGroupMainFlex'>
                                                        <div className='listItemGroupIcon'>
                                                            <img
                                                                loading="lazy"
                                                                src={user}
                                                                className='mainSvg'
                                                                alt="Prod." />
                                                        </div>

                                                        <div className='listItemGroupText' >                                                            <span style={{ color: '#164978' }}>
                                                                {employee.nmpe}
                                                            </span>
                                                        </div>

                                                        <div className='listItemGroupDates'>
                                                            <span style={{ color: '#164978', textDecoration: 'none', }}>
                                                                Obra: <strong> {employee.cct}</strong>
                                                            </span>
                                                        </div>

                                                        <div className='listItemGroupoptions'>
                                                            {selectedList.includes(employee.npe) ?
                                                                <img
                                                                    loading="lazy"
                                                                    src={checkbox}
                                                                    className='mainSvg'
                                                                    alt="Prod."
                                                                    style={{ filter: 'brightness(0) saturate(100%) invert(20%) sepia(100%) saturate(816%) hue-rotate(180deg) brightness(90%) contrast(91%)' }}
                                                                />
                                                                :
                                                                <img
                                                                    loading="lazy"
                                                                    src={unchecked}
                                                                    className='mainSvg'
                                                                    alt="Prod."
                                                                    style={{ filter: 'brightness(0) saturate(100%) invert(20%) sepia(100%) saturate(816%) hue-rotate(180deg) brightness(90%) contrast(91%)' }}
                                                                />
                                                            }
                                                        </div>
                                                    </div>
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                :
                                <div className="noProdcutionWarning" style={{ flex: '1', margin: 0, minHeight: '260px', flexDirection: 'row' }}>
                                    <div className='noProdcutionCenterIcon' style={{ flexDirection: 'row', minWidth: '290px'}}>
                                        <img src={nodoc} alt="Carrinha" style={{ height: '72px', width: '72px', marginRight: '15px'}} />
                                        <p className='noProductionCenterText' style={{ textAlign: 'left' }}>Não existem atualmente <br></br>funcionários em obras...</p>
                                    </div>
                                </div>
                        }
                    </div>
                    
                    <div className="modal-footer">
                        <button
                            onClick={e => dismissModal()}
                            className={'modalBtn'}
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={e => nextClick()}
                            className={'modalBtn success'}
                        >
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    function dismissModal() {
        params.closeModal();
    }

    return (
        <div>
            <CSSTransition
                in={params.isOpen}
                timeout={300}
                classNames="dialog"
            >
                <Modal
                    closeTimeoutMS={360}
                    isOpen={params.isOpen}
                    className="Modal"
                    overlayClassName="Overlay"
                    size="xl"
                    disableAutoFocus={true}
                    toggle={e => console.log()}
                >
                    {renderContent()}
                </Modal>
            </CSSTransition>
        </div>
    )
}
export default ModalPickupFuncionario